import api from './api';

export interface DifformityReport {
  id: string;
  userId: string;
  an_conto?: number | null;
  clientCompany: string;
  clientEmail: string;
  sku: string;
  productTitle: string;
  productBrand: string;
  message: string;
  createdAt: string;
  updatedAt: string;
  status: 'nuova' | 'in_gestione' | 'chiusa';
  adminNote?: string | null;
}

export interface DifformityListResponse {
  items: DifformityReport[];
  total: number;
  page: number;
  limit: number;
  pages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const difformityService = {
  create: async (payload: {
    sku: string;
    productTitle: string;
    productBrand?: string;
    message: string;
  }): Promise<void> => {
    await api.post('/api/clienti/me/difformita', payload);
  },

  adminList: async (params: {
    page?: number;
    page_size?: number;
    search?: string;
    status?: string;
  }): Promise<DifformityListResponse> => {
    const { data } = await api.get<DifformityListResponse>('/api/admin/difformita', { params });
    return data;
  },

  adminGet: async (id: string): Promise<DifformityReport> => {
    const { data } = await api.get<DifformityReport>(`/api/admin/difformita/${id}`);
    return data;
  },

  adminUpdate: async (id: string, payload: { status: string; adminNote?: string }): Promise<DifformityReport> => {
    const { data } = await api.patch<DifformityReport>(`/api/admin/difformita/${id}`, payload);
    return data;
  },
};
